import { render } from "./ParkingStatusCard.vue?vue&type=template&id=3836bd0d&ts=true"
import script from "./ParkingStatusCard.vue?vue&type=script&lang=ts"
export * from "./ParkingStatusCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__